import { PATH_FINANCE } from './paths';
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthProtect from 'src/components/Auth/AuthProtect';
import DashboardFinanceLayout from 'src/layouts/DashboardFinanceLayout';

// ----------------------------------------------------------------------

const AppFinanceRoutes = {
  path: PATH_FINANCE.root,
  guard: AuthProtect,
  layout: DashboardFinanceLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------

    // DASHBOARD
    {
      exact: true,
      path: PATH_FINANCE.general.dashboard,
      component: lazy(() => import('src/views/FinanceDashboardGroup/dashboard/DashboardAppView'))
    },

    // INVOICE
    {
      exact: true,
      path: PATH_FINANCE.general.invoice,
      component: lazy(() => import('src/views/FinanceDashboardGroup/invoice/Invoice'))
    },
    {
      exact: true,
      path: PATH_FINANCE.general.invoiceEdit,
      component: lazy(() => import('src/views/FinanceDashboardGroup/invoice/invoice-details/EditInvoice'))
    }
  ]
}

export default AppFinanceRoutes
